<template>
  <a-modal name="respond-complete">
    <div  class="respond-complete" @click.self="closeModal">
      <div class="bg-color" @click.self="closeModal"></div>
      <form class="respond-complete-modal">
        <h2 class="respond-complete-modal__title">
          {{result.title}}
        </h2>
        <div class="row">
          <div class="col sm-12" :class="'d'+field.greedLang" v-for="field in fields">
            <AInput
                v-if="field.type=='text'||field.type=='textarea'"
                v-model="field.value"
                @click="field.error=false"
                :type="field.type"
                :error="field.error"
                :staticLabel="true"
                :hint="field.maxLength?textLimitHint(field.value,field.maxLength):field.hint"
                :label="field.title"
            />
            <a-checkbox
                v-else-if="field.type=='checkbox'"
                :name="field.name"
                @click="field.error=false"
                :disabled="field.disabled"
                :label="field.title"
                :error="field.error"
                :checked="field.disabled||field.value?true:false"
                v-model="field.value"
            />
            <div v-else-if="field.type=='file'">
              <a-input
                  v-for="(oneFile,i) in field.value"
                  class="field-dnd"
                  :label="field.title"
                  @click="field.error=false"
                  :placeholder="field.placeholder"
                  :hint="field.hint"
                  :name="field.name"
                  staticLabel
                  :type="field.type"
                  v-model="field.value[i]"
                  :error="field.error"
              />
              <ABtn
                  class="form-btn btn-add"
                  fill="transparent"
                  type="button"
                  @click="more(field)"
                  v-if="field.multiple&&field.maxCountFiles>field.value.length">
                <template #before>
                  <svg class="icon" width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <rect y="9" width="20" height="2"/>
                    <rect x="9" y="20" width="20" height="2" transform="rotate(-90 9 20)"/>
                  </svg>
                </template>
                <template #content>{{field.moreBtn}}</template>
              </ABtn>
            </div>
          </div>
        </div>
        <div class="respond-complete-buttons">
          <ABtn :label="result.btn.complete.title" bg="#00A59E" @click.prevent="CompleteAction"/>
          <ABtn @click.prevent="closeModal" class="respond-complete-reset" :label="result.btn.cancel.title" bg="transparent" color="#00A59E" type="reset" />
        </div>
      </form>
    </div>
  </a-modal>
</template>

<script>
import {useAModal, AModal, AInput, ABtn, ACheckbox, useAProgressBar} from "~/components/ui";
import { ref } from 'vue'
import { validateFormItem } from '~/libs/Validators'
import {send} from "../../../services/api";
export default {
  name: "RespondComplete",
  props: ['result',"taskId","respId"],
  components: {
    AModal,
    ACheckbox,
    AInput,
    ABtn,
  },
  setup(props) {
    const modal = useAModal();
    const progress = useAProgressBar();
    const closeModal = () => {
      modal.hide();
    }
    const fields = ref(props.result.fields);
    for (let index in fields.value) {
      if(typeof fields.value[index] == "object") {
        if(fields.value[index].multiple&&fields.value[index].value.length==0) {
          fields.value[index].value.push(false);
        }
      }
    }
    const more = (field) => {
      if(field.maxCountFiles>field.value.length) {
        field.value.push(false);
      }
    }
    const CompleteAction = async () => {
      let canSend = true;
      let formData = new FormData();
      for (let index in fields.value) {
        if (typeof fields.value[index] == "object") {
          let r = validateFormItem(fields.value[index]);
          // console.log(r);
          if (r.valid) {
            for (let valIndex in r.value) {
              if (typeof r.value[valIndex] == 'object') {
                formData.append(r.value[valIndex].name, r.value[valIndex].value);
              }
            }
            // console.log(r.value);
          } else {
            fields.value[index].error = true;
            canSend = false;
          }
        }
      }
      if (canSend) {
        for (let key in props.result.btn.complete.action.data) {
          formData.append(key, props.result.btn.complete.action.data[key]);
        }
        formData.append('taskId', props.taskId);
        formData.append('responseId', props.respId);
        progress.show();
        await send(props.result.btn.complete.action.link, {method: "POST"}, formData).then((response) => {
          if(response.error) {
            showNotification('danger','',response.error);
            progress.hide();
          } else if(response.success) {
            showNotification('success','',response.success);
            setTimeout(()=>{location.reload();},1500);
          }
        });
      }
    }
    return {
      fields,
      more,
      closeModal,
      CompleteAction,
    }
  }
}
</script>

<style lang="scss" scoped>
.bg-color {
  width: 100%;
  height: 50vh;
  background: #6367A7;
}
.respond-complete {
  min-height: 100vh;
  background-color: #fff;
}
.respond-complete-background{
  position: absolute;
  display: block;
  width: 100%;
  height: auto;
  pointer-events: none;
}
.respond-complete-modal{
  position: absolute;
  max-width: 684px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #FFFFFF;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px 40px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  padding: 45px 64px 60px 57px;
  width: 100%;
  max-height: 100vh;
  overflow-y: auto;
  @include mobile{
    padding: 20px;
  }
  &__title{
    margin: 0 0 36px;
  }
  &__text{
    font-size: 14px;
    line-height: 20px;
    color: #161515;
    margin-bottom: 12px;
  }
  &__subText{
    font-size: 12px;
    line-height: 16px;
    color: #68737D;
    margin-bottom: 29px;
  }
  :deep{
    .label{
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #68737D;
    }
    .field{
      margin-bottom: 0px;
    }
    .respond-complete-file{
      margin: 0 0 3px;
    }
  }
}
.respond-complete-reset{
  border: 1px solid #00A59E;
}
.respond-complete-add{
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  color: #68737D;
  margin-bottom: 35px;
  cursor: pointer;
  &__icon{
    margin-right: 11px;
  }
}
.respond-complete-buttons{
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 23px;
  margin-top: 24px;
  @include mobile{
    grid-template-columns: 1fr;
  }
}
.respond-complete-files{
  display: grid;
  grid-row-gap: 5px;
  margin-bottom: 15px;
}
</style>